<style>
    hslayers {
      position: relative; 
      height: 100vh
    }
    @media only screen and (max-width: 600px) {
    hslayers {
      height: calc(100vh - 96px)
    }
  }
</style>
<hslayers></hslayers>